import MetaInfoList from "components/MetaInfoList";
import TimestampMetaInfo from "components/Timestamp/MetaInfo";
import ViewHeader from "components/ViewHeader";
import ViewHeaderScrollCollapse from "components/ViewHeader/ScrollCollapse";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import { showCancelScanRunModal } from "shared/Scan/CancelScanRunModal";
import ScanRunStateBadge from "shared/Scan/StateBadge";
import { showStopScanRunModal } from "shared/Scan/StopScanRunModal";
import useCancelScanRun from "shared/Scan/useCancelScanRun";
import useStopScanRun from "shared/Scan/useStopScanRun";
import { GET_SCAN_DETAIL } from "views/Account/Scans/ScanDetail/gql";
import { SEARCH_SCAN_RUNS, SEARCH_SCAN_RUNS_COUNT } from "views/Account/Scans/ScanDetail/Scans/gql";

import { getScanRunTitle } from "../../helpers";
import { GET_SCAN_RUN } from "../../gql";
import { ScanRunDetailItem } from "../../types";

type ScanRunHeaderProps = {
  run: ScanRunDetailItem;
};

const ScanRunHeader = ({ run }: ScanRunHeaderProps) => {
  const refetchQueries = [
    { query: GET_SCAN_RUN, variables: { id: run.id } },
    { query: GET_SCAN_DETAIL, variables: { id: run.scan.id } },
    SEARCH_SCAN_RUNS,
    SEARCH_SCAN_RUNS_COUNT,
  ];
  const { canCancel, showCancel } = useCancelScanRun({ scanRun: run });
  const { canStop, showStop } = useStopScanRun({ scanRun: run });

  return (
    <ViewHeader>
      <ViewHeaderWrapper direction="row" justify="between" fullWidth>
        <ViewHeaderWrapper direction="row" align="center">
          <ViewHeaderTitle>{getScanRunTitle(run.createdAt)}</ViewHeaderTitle>
          <ScanRunStateBadge state={run.state} />
        </ViewHeaderWrapper>

        {(showCancel || showStop) && (
          <ViewHeaderWrapper direction="row" align="end" shrink="0">
            {showCancel && (
              <Tooltip
                active={!!canCancel.message}
                on={(tooltipProps) => (
                  <Button
                    {...tooltipProps}
                    variant="secondary"
                    disabled={!canCancel.result}
                    onPress={() => showCancelScanRunModal({ scanRun: run, refetchQueries })}
                  >
                    Cancel
                  </Button>
                )}
              >
                {canCancel.message}
              </Tooltip>
            )}
            {showStop && (
              <Tooltip
                active={!!canStop.message}
                on={(tooltipProps) => (
                  <Button
                    {...tooltipProps}
                    variant="secondary"
                    disabled={!canStop.result}
                    onPress={() => showStopScanRunModal({ scanRun: run, refetchQueries })}
                  >
                    Stop
                  </Button>
                )}
              >
                {canStop.message}
              </Tooltip>
            )}
          </ViewHeaderWrapper>
        )}
      </ViewHeaderWrapper>

      <ViewHeaderScrollCollapse>
        <MetaInfoList>
          <TimestampMetaInfo prefix="Updated" timestamp={run.stateChangedAt} />
        </MetaInfoList>
      </ViewHeaderScrollCollapse>
    </ViewHeader>
  );
};

export default ScanRunHeader;
